import React from 'react';
import {
  Button,
  Col,
  Container,
  //Alert,
  //Nav,
  //Navbar,
  Row,
  Form,
  //Input,
  Stack
} from 'react-bootstrap';
import '../../App.css';
import utils from '../../utils'
import EcuComps2 from '../../comp/EcuComps2'
import MyCan from '../../MyCan';
import {MyCanUtils} from '../../MyCan'; // Ensure this path is correct
import LoadingSpinner from "../../comp/gen/LoadingSpinner"
import UserAuthRequired from "../../comp/gen/UserAuthRequired"

// ****************************************************************************

class EcuActions {
  constructor(ecu, setState) {
    this.ecu = ecu;
    this.setState = setState;
  }
  async updateSign(bitrate) {
    await this.setState({ ecu_comps: [] })
    this.ecu.updateSign(bitrate)
  }
  async runTest(bitrate) {
    await this.setState({ ecu_comps: [] })
    this.ecu.runTest(bitrate)
  }
  async readInfo(bitrate) {
    await this.setState({ ecu_comps: [] })
    this.ecu.readInfo(bitrate)
  }
  async program010(bitrate) {
    await this.setState({ ecu_comps: [] })
    this.ecu.program010(bitrate)
  }  
  async setComPort() {
    await this.setState({ ecu_comps: [] })
    this.ecu.selectComPort()
  }
  stopCom() {
    console.log("stop pressed")
    this.ecu.stopComDone()
  }
}

export default class MP_CAN_DEMO extends React.Component {
  constructor(props) {    
    super(props); 
    this.ecu = new MyCan()
    this.ecu.progressChanged = this.ecu_progress_changed.bind(this)
    this.ecu.comPortChanged = this.ecu_com_port_changed.bind(this)
    this.ecuActions = new EcuActions(this.ecu, this.setState.bind(this));

    this.state = { 
      working: 0,
      ecu_comps: [],            
      usb_selected: false,
      can_messages: [],
      _program_block_progress: "0.0%",
      bitrate: 1, // Default: 500 kbit/s
    };
    // debug
    if ("serial" in navigator) {
      console.log("supported !") 
    }
  }

  ecu_com_port_changed(o) {
    if (o === undefined) {
      this.setState({
        usb_selected: false,
      })
      return 
    }
    this.setState({
      usb_selected: true,
    })
  }
  ecu_progress_changed(o) {    
    if (o.type === "_working") {
      this.setState({
        working: o.data        
      })
    } else if (o.type === "_program_block") {
      ////////console.log(o.data)
      this.setState({
        _program_block_progress: (100.0 * o.data.pos / o.data.size).toFixed(1) + "%"
      })
    } else {
      this.setState(prevState => ({
        ecu_comps: [
          ...prevState.ecu_comps,
          o,
        ]
      }))
    }    
    //console.log("STATE")
    //console.log(this.state)
  }
  
  render() { 
    //console.log(this.props)
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />
    if (!utils.userHasRoleAdmin(this.props.authStatus.user)) return <UserAuthRequired notallowed />

    var buttons_en = !(this.state.working === 1)  
    var height = "calc(100vh - " + this.props.navbarHeight + ")"  
    return (
      <>          
        <Container fluid style={{ border: '0px solid gray', height: height, overflow: 'hidden' }}>
          <Row style={{ height: '100%', marginBottom: "15px" }}> 
          <Col style={{ border: '0px solid gray' }}>      
            <br />
          </Col>
          <Col>
            <Stack gap={3}>
              <Button 
                  variant="outline-secondary" 
                  disabled={!buttons_en}  
                  onClick={e => this.ecuActions.setComPort()}>SET COM PORT</Button>
              <Form.Select
                aria-label="Select CAN bitrate"
                value={this.state.bitrate}
                onChange={(e) => this.setState({ bitrate: parseInt(e.target.value) })} >
                  <option value={0}>250 kbit/s</option>
                  <option value={1}>500 kbit/s</option>
                  <option value={2}>1 Mbit/s</option>
              </Form.Select>
              <br />
              <Button 
                  variant="success" 
                  disabled={!buttons_en} 
                  onClick={e => this.ecuActions.runTest()}>run test</Button>
              <Button 
                  variant="success" 
                  disabled={!buttons_en} 
                  onClick={e => this.ecuActions.updateSign()}>update sign</Button>
              <Button 
                  variant="success" 
                  disabled={!buttons_en} 
                  onClick={e => this.ecuActions.readInfo()}>read info</Button>
              <Button 
                  variant="success" 
                  disabled={!buttons_en} 
                  onClick={e => this.ecuActions.program010()}>MP32_PLUS-010-0002</Button>
              <p>PROGRAM PROGRESS: {this.state._program_block_progress}</p>
              <Button 
                variant="info" 
                onClick={e => this.ecuActions.stopCom()}>STOP</Button>   
              <Button 
                variant="primary" 
                onClick={e => this.handleSaveToFile()}>Save to File</Button>  
            </Stack>

            <Stack gap={3} style={{ marginTop: "15px" }}>
              <EcuComps2 ecu_comps={this.state.ecu_comps} />
            </Stack>                
          </Col> 
        </Row>
      </Container>        
    </>
  )}
}
